import {css} from 'lit';
export const styles = css`:host {
  display: block;
  padding: 4px 8px;
  padding: var(--chat-msg-reply-padding, 4px 8px);
  margin-bottom: 0;
  margin-bottom: var(--chat-msg-reply-margin-bottom, 0);
  border-left: 4px solid var(--primary-300);
  border-left: 4px solid var(--chat-msg-reply-border-color, var(--primary-300));
  border-radius: 6px;
  border-radius: var(--chat-msg-reply-border-radius, 6px);
  background-color: var(--primary-000);
  background-color: var(--chat-msg-reply-background, var(--primary-000));
  color: inherit;
  color: var(--chat-msg-reply-color, inherit);
  font-size: 0.9em;
  font-size: var(--chat-msg-reply-font-size, 0.9em);
}

.sender {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  color: var(--chat-msg-reply-sender-color);
  font-size: 0.9em;
  font-weight: 600;
  overflow: hidden;
}

ef-truncate {
  --btn-align: left;
  --mask-color: var(--chat-msg-reply-background);
  --btn-divider: none;

  margin-bottom: 0;
}

ef-truncate .truncate-content {
    word-break: break-word;
    white-space: pre-wrap;
  }

.attachment {
  margin-top: 4px;
  margin-bottom: 4px;
}

.attachment ef-attachment {
    display: inline;
  }

picture {
  display: block;
}

picture img {
    display: block;
    max-width: 60px;
    max-height: 60px;
    min-width: 60px;
    object-fit: cover;
    cursor: zoom-in;
  }
`;
export default styles;
